<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-content>
        <ion-list id="inbox-list">
          <div style="text-align: center; margin-top: 10px;">
            <img *ngIf="currentParish?.ParishLogo" [src]="currentParish?.ParishLogo" alt="App Logo"
              style="max-height: 100px; " />
          </div>
          <ion-list-header>
            {{currentParish?.ParishName}}
          </ion-list-header>
          <ion-item *ngIf="userService.currentUser?.UserId">
            <img src="assets/icon/myaccount.png" aria-hidden="true" width="35" slot="start">
            <ion-label (click)="showProfile()"><b>{{userService.currentUser?.UserFullName}}</b></ion-label>
          </ion-item>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages; let i = index">
            <ion-item *ngIf="p.url?.startsWith('http')" [href]="[p.url]" lines="none" detail="false"
              routerLinkActive="selected">
              <img src="assets/icon/sidemenu.png" aria-hidden="true" width="35" [alt]="p.title" slot="start">
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>

            <ion-item *ngIf="!p.url.startsWith('http') && isMenuItemVisible(p)" routerDirection="root"
              [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
              <img [src]="p.icon" aria-hidden="true" width="35" [alt]="p.title" slot="start">
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list id="labels-list">
          <ion-item *ngFor="let label of labels" lines="none">
            <ion-icon aria-hidden="true" slot="start" ios="bookmark-outline" md="bookmark-sharp"></ion-icon>
            <ion-label>{{ label }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>

      <ion-toast [isOpen]="isToastOpen" [message]="toastMessage" [duration]="duration" [buttons]="toastButtons"
        (didDismiss)="setOpen(false)"></ion-toast>

      <ion-loading [isOpen]="isLoading" message="Loading..." spinner="circles"></ion-loading>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>